import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity } from '@pit/core';
import { IDtoStatsDepotShipments } from '../interfaces/dto.stats.depot.shipments.interface';
import { ShipmentProcessState } from '../interfaces/dto.shipment.process.interface';

// @dynamic
@JsonObject('DtoStatsDepotShipments')
export class DtoStatsDepotShipments extends ModelEntity implements IDtoStatsDepotShipments {

    constructor(initValues: Partial<IDtoStatsDepotShipments> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('depot', String, true)
    public depot?: string = null;

    @JsonProperty('processState', Number, true)
    public processState?: ShipmentProcessState = ShipmentProcessState.Unknown;

    @JsonProperty('amount', Number, true)
    public amount?: number = null;

}
